import { reAuthenticate } from "../AzureADConfig";

export const handleResponse = async (response: Response) => {
  return response.text().then((text: string) => {
    let data : any;

    try {
      data = JSON.parse(text);
    } catch (error) {
      data = text;
    }

    if (!response.ok) {
      let responseText = response.statusText;
      if (response.status === 403) {
        window.location.href = '/authorization-error';
        return data;
      }else if(response.status === 401){
        reAuthenticate();
      }else if(response.status >= 500 && response.status < 600){
        throw new Error('API not responding');
      }

      const serverErrors = data.errors
        ? Object.keys(data.errors || {})
            .map(key => `${data.errors[key]}`)
            .join('\r\n')
        : Object.keys(data || {})
            .map(key => `${data[key]}`)
            .join('\r\n');

      const error = serverErrors || responseText;

      return Promise.reject(error);
    }

    return data;
  });
};
